import { format } from 'date-fns';
import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { IHistory } from '../../../interfaces';
import { DailyFormsModel } from '../../../model/DailyFormModel';
import { inspectionType } from '../../../constants/generals';

export interface IListItemProps {
    instance: DailyFormsModel;
    index: number;
    listItemProp: string;
    history: IHistory;
}

export class ListItemImpl extends React.PureComponent<IListItemProps, {}> {

    static defaultProps: IListItemProps;

    render() {
        const { instance, index, history } = this.props;
        if (!instance) {
            return <div></div>;
        }
        const { PlantId, Date: date, type, Region, UserName, SubmittedDate } = instance.props;
        const formType = type.toLowerCase() === 'dailyform' ? 'daily' : type ;
        return <Row className="form-list-item" >
            <Col
                onClick={() => 
                    /*tslint:disable-next-line*/
                history.push(`/reports/${formType}/${instance.props.id}/${Region}/${PlantId}/${format(date, 'MM-DD-YYYY')}/${UserName}`)}

                className="clickable-list-item serial-no"
                sm={1}
                xs={1}
            >
                {index}
            </Col>
            <Col
                onClick={() => 
                    /*tslint:disable-next-line*/
                    history.push(`/reports/${formType}/${instance.props.id}/${Region}/${PlantId}/${format(date, 'MM-DD-YYYY')}/${UserName}`)}
                className="clickable-list-item"
                xs={3}
                sm={3}
            >
                {PlantId}
            </Col>
            <Col
                onClick={() => 
                    /*tslint:disable-next-line*/
                    history.push(`/reports/${formType}/${instance.props.id}/${Region}/${PlantId}/${format(date, 'MM-DD-YYYY')}/${UserName}`)}
                className="clickable-list-item"
                xs={3}
                sm={3}
            >
                {Region}
            </Col>
            <Col
                onClick={() => 
                    /*tslint:disable-next-line*/
                    history.push(`/reports/${formType}/${instance.props.id}/${Region}/${PlantId}/${format(date, 'MM-DD-YYYY')}/${UserName}`)}
                className="clickable-list-item"
                xs={3}
                sm={3}
            >
               {inspectionType(instance.props.type)}
            </Col>
            <Col
                onClick={() =>
                    /*tslint:disable-next-line*/ 
                    history.push(`/reports/${formType}/${instance.props.id}/${Region}/${PlantId}/${format(date, 'MM-DD-YYYY')}/${UserName}`)}
                className="clickable-list-item"
                xs={2}
                sm={2}
            >
                {format(SubmittedDate, 'MM/DD/YYYY')}
            </Col>
        </Row>;
    }
}

export function mapStateToProps(state) {
    return {
        state
    };
}

export const ListItem = withRouter(connect<{}, {}, IListItemProps>(mapStateToProps)(ListItemImpl as any));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Reports/Daily/ListItem.tsx